import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/palette";

type Props = {
  compareUsersList: { items: any[] };
  label: string;
  dataKey: string;
  isLastRow: boolean;
};

const IMG_URL = "https://cdn.staging.goalngo.com/";

const CompareRowFlag = ({ compareUsersList, label, dataKey, isLastRow }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "17px 27px",
        borderBottom: "1px solid #EAECF0",
        gap: "66px",
      }}
    >
      <Box sx={{ width: "237px" }}>
        <Typography
          variant="body14Bold"
          sx={{
            fontWeight: 700,
            color: colors.Dark1000,
          }}
        >
          {label}
        </Typography>
      </Box>
      {compareUsersList?.items?.map((user: any, index: number) => (
        <Box
          sx={{
            width: "148px",
            textAlign: "center",
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
          }}
          key={index}
        >
          {Array.isArray(user[dataKey]) ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {user[dataKey].map((item: any, idx: number) => (
                <Box
                  key={idx}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body14Regular"
                    sx={{
                      color: colors.Dark1000,
                    }}
                  >
                    {item.name}
                  </Typography>
                  <img src={IMG_URL + item.url} width="12" height="9" alt="Nationality" style={{ marginLeft: 4 }} />
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ display: "inline-flex", alignItems: "center" }}>
              <Typography
                variant="body14Regular"
                sx={{
                  color: colors.Dark1000,
                }}
              >
                {user[dataKey].name}
              </Typography>
              <img
                src={IMG_URL + user[dataKey].url}
                width="12"
                height="9"
                alt="Nationality"
                style={{ marginLeft: 4 }}
              />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default CompareRowFlag;
